// Management -> Field templates (N6, 2026-10-14; templates since task F, 2026-10-20): an admin's
// templates of additional fields for the project card, studies and datasets. A template is only
// COPIED into a project (its curators' "Add from templates", or at creation when it is a default
// for new projects); a later change of the template reaches no copy. The editor is shared with
// the project's Field settings: forms/FieldDefinitionEditor.jsx (the API it calls is listed there).
import FieldDefinitionEditor from "../../forms/FieldDefinitionEditor";

export { fieldBody } from "../../forms/FieldDefinitionEditor";

export default function FieldsCard() {
  return (
    <div>
      <p style={{ margin: "0 0 14px", fontSize: 14, color: "#374151", maxWidth: 820 }}>
        Field templates are ready-made additional fields for the project card, studies and datasets.
        Each project has its own fields, which its curators define in the project's Field settings; there
        they can add a copy of a template with "Add from templates". Templates marked "default for new
        projects" are copied into every project created from now on.
      </p>
      <p role="note" style={{ margin: "0 0 14px", fontSize: 14, color: "#374151", maxWidth: 820 }}>
        <strong>Changes to a template do not reach the projects that copied it.</strong> A copy belongs to its
        project and is changed only there.
      </p>
      <FieldDefinitionEditor base="/admin/fields" kind="template" />
    </div>
  );
}
